import { render } from "./switchSetting.vue?vue&type=template&id=21e3e654"
import script from "./switchSetting.vue?vue&type=script&lang=js"
export * from "./switchSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__